export const descripion = 'The FL Gold Coin Exchange sales and buys rare coins, gold coins, silver coins, platinum coins, paper money, medals.Call us(+1) - 727 - 656 - 2974'
